var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"svg-icon",attrs:{"fill":_vm.iconColor}},[_c('use',{attrs:{"xlink:href":_vm.iconNameCp}})])}
var staticRenderFns = []

export { render, staticRenderFns }